(function () {
  function panelFor(toggle) {
    return toggle.nextElementSibling;
  }

  // scrollHeight at open-time and never revisited. Expanding a NESTED
  // tier-2 group accordion ("Themed Collections" etc — the vendor's own
  // separate disclosure widget, main.js's handleTransitionEnd) inside an
  // already-open tier-1 panel grows real content that this panel's now-
  // stale fixed height + overflow:hidden silently clips: confirmed live
  // on avd-5, the "2026/2025/2024 Stickers" rows disappear entirely once
  // "Themed Collections" expands — panel.scrollHeight reads 753 while
  // panel.style.height stays locked at the original 369.
  //
  // A ResizeObserver can't watch the panel itself for this — its OWN box
  // is exactly what we're constraining, so its reported size never
  // changes even while its content wants more room. It has to watch the
  // panel's CONTENT children instead, whose natural (unclamped) size
  // actually grows when tier-3 expands. The callback re-applies the same
  // scrollHeight-to-height assignment the initial open already uses, so
  // it rides the SAME CSS transition (sp-mobile-drawer.css `transition:
  // height 0.35s ...`) — no new animation code, just keeping the target
  // current as content changes underneath it.
  // SP OVERRIDE (2026-08-18, cont.): the re-measure above only ever grew
  // the panel, never shrank it. Cause: scrollHeight is floored by the
  // element's OWN current clientHeight — once panel.style.height holds a
  // pixel value, panel.scrollHeight can never report smaller than that
  // again, no matter how much the nested content collapses. Confirmed
  // live on avd-5: closing a nested group correctly shrinks its own
  // container (verified via that element's own offsetHeight), but the
  // panel height re-application was stuck at its historical peak,
  // leaving a large dead blank gap below the real content and an
  // equally stale (too-large) drawer scrollHeight — reads as "the bottom
  // gets all messed up" once a user has scrolled into that gap.
  // Fix: clear to auto first so scrollHeight reflects the CURRENT
  // natural size, unfloored by the previous explicit height, then
  // reapply as a pixel value. Both writes happen synchronously in the
  // same callback tick, so the browser never paints the intermediate
  // auto state and the existing height transition is undisturbed.
  // SP OVERRIDE (2026-09-18): the re-measure above must NOT run while the
  // panel is still opening, or it destroys the opening animation outright.
  //
  // ResizeObserver.observe() delivers an INITIAL callback for every element
  // the moment it is observed, and openItem() observes the children in the
  // same tick as it sets the opening height. That callback's own first act —
  // height:'auto' followed by a scrollHeight read — forces a synchronous
  // layout at the FULL height, so the browser commits 370px as the animation's
  // START value and the 0 -> 370 transition never exists.
  //
  // two height writes 2ms apart, both "370px"; click to first paint 19.3ms and
  // settle at the same 19.3ms; ZERO transitionrun events. The panel snapped.
  // Writing the height by hand animated correctly every time, which is what
  // narrowed it to the observer rather than to the CSS — the transition was
  // declared, matched, and simply had no distance left to cover.
  //
  // openingPanels holds a panel from the click until the frame after the
  // initial callbacks have been delivered, so a real nested expansion (the
  // clipping case this observer exists for) still re-measures, and only the
  // spurious initial burst is skipped.
  var openingPanels = new WeakSet();

  var panelResizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var panel = entry.target.parentElement;
      if (!panel || !panel.classList.contains('navigation__tier-2-container')) return;
      if (openingPanels.has(panel)) return;
      panel.style.height = 'auto';
      panel.style.height = panel.scrollHeight + 'px';
    });
  });

  function closeItem(li) {
    var toggle = li.querySelector(':scope > .navigation__children-toggle');
    var panel = toggle ? panelFor(toggle) : null;
    li.classList.remove('navigation__item--open');
    if (panel) {
      Array.from(panel.children).forEach(function (child) {
        panelResizeObserver.unobserve(child);
      });
      panel.style.height = '';
    }
  }

  function openItem(li) {
    var toggle = li.querySelector(':scope > .navigation__children-toggle');
    var panel = toggle ? panelFor(toggle) : null;
    if (!panel) return;
    // with their parent. Done BEFORE the parent measures itself, with the group's own height transition
    // suppressed for that one write, so the parent's scrollHeight already includes the open group and the
    // whole panel slides open as one motion instead of growing a second time.
    panel.querySelectorAll('[data-sp-auto-open]').forEach(function (group) {
      var sub = group.querySelector(':scope > .navigation__children-toggle + *');
      if (!sub || !sub.firstElementChild) return;
      group.classList.add('navigation__item--open');
      sub.style.transition = 'none';
      sub.style.height = sub.firstElementChild.clientHeight + 'px';
      void sub.offsetHeight;
      sub.style.transition = '';
    });
    li.classList.add('navigation__item--open');
    panel.style.height = panel.scrollHeight + 'px';
    // Guard the opening transition against the observer's initial callbacks
    // (see openingPanels above). Two frames: the first rAF still runs before
    // the delivery of those callbacks, the second is safely after them.
    openingPanels.add(panel);
    Array.from(panel.children).forEach(function (child) {
      panelResizeObserver.observe(child);
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        openingPanels.delete(panel);
      });
    });
  }

  document.addEventListener(
    'click',
    function (evt) {
      var toggle = evt.target.closest(
        '.mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__children-toggle'
      );
      if (!toggle) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var li = toggle.parentElement;
      var drawer = li.closest('.mobile-navigation-drawer');
      var wasOpen = li.classList.contains('navigation__item--open');

      drawer.querySelectorAll('.navigation__tier-1 > .navigation__item--open').forEach(function (openLi) {
        if (openLi !== li) closeItem(openLi);
      });

      if (wasOpen) {
        closeItem(li);
      } else {
        openItem(li);
      }
    },
    true
  );
})();
